import { useEffect } from "react";

import { useGetDeviceType } from "_common/hooks/global";

export function useProModalScrollLock ( opened ) {
	const deviceType = useGetDeviceType ();

	useEffect ( () => {
		const el = document.getElementById ( "right-side-element" );

		if ( !el )
			return;

		if ( deviceType === "mobile" ) {
			el.style.overflow = "unset";

			return;

		}

		if ( opened ) {
			if ( el ) {
				el.style.overflow = "hidden";

				return;
			}

		}

		el.style.overflow = "auto";

	}, [ opened ] );
}

export const benefitsList = ( { avatarsList, selected = {} } ) => {
	const contentBenefits = [
		{
			title       : "Streams of all Pro Channels",
			avatarsList : avatarsList,
			icon        : "proUserProfile"
		},
		/* {
      title : "Get access to all “Watch Ad” Streams.",
      icon  : "proAds"
    }, */
		{
			title : "Enjoy video quality up to 1080p",
			icon  : "proHD"
		},
		{
			title : "Seek in Pro Streams",
			icon  : "proPlay"
		},
		{
			title : "Lesser Ads",
			icon  : "proNoAd"
		},
		{
			title : "Pro badge next to your name",
			icon  : "proBadge"
		}
	];

	const rewardsShop = [
		{
			title : "500 Rooter Diamonds worth Rs.50",
			icon  : "proDiamonds"
		},
		{
			title : "Up to 50% off on Rooter shop purchases",
			icon  : "proDiamonds"
		},
		{
			title : "Extra cash back on shop purchases",
			icon  : "proDiamonds"
		},
		{
			title : "Get 1 month of Chess.com Premium.",
			icon  : "proDiamonds"
		}
	];

	const addedBenefits = [];

	if ( selected?.diamonds )
		addedBenefits.unshift ( {
			// - Get $ Rooter Diamonds worth Rs.
			title    : "100% Cashback on Subscription -",
			subtitle : [
				"Step 1 - Purchase Monthly Pro Subscription",
				`Step 2 - Keep your subscription active for atleast 15 Days and get ${ selected?.diamonds } diamonds as Cashback`,
				`Step 3 - Once rewarded go to the Diamonds section in the app to view your ₹${ selected?.diamondsWorth } worth of Diamonds`,
				"Step 4 - Redeem your Rooter Diamonds for cash"
			],
			icon: "proDiamonds"
		} );

	/* addedBenefits.push ( {
    title : "Pro App Icon",
    icon  : "proRooterIcon"
  } ); */

	const finalRes = [];

	if ( contentBenefits?.length )
		finalRes.push ( {
			title : "BENEFITS",
			list  : contentBenefits
		} );

	if ( addedBenefits?.length )
		finalRes.push ( {
			title : "Exclusive Offer",
			list  : addedBenefits
		} );

	/* {
      title : "REWARD & SHOP BENEFITS",
      list  : rewardsShop
    }, */

	return finalRes;
};

export const deducePeriod = days => {
	if ( days === 7 )
		return "week";

	if ( days === 30 )
		return "month";

	if ( days === 365 )
		return "year";

	if ( days === 180 )
		return "6 months";

	else return `${ days } days`;
};
/**
 * @param {number} days
 * @returns {string}
 */
export const getPlanName = days => {
	if ( days === 7 )
		return "1 Week";

	if ( days === 30 )
		return "1 Month";

	if ( days === 365 )
		return "1 Year";

	if ( days === 180 )
		return "6 Months";

	else return `${ days } days`;
};
